import React from "react";
import { Modal } from "react-bootstrap";
import { BACKGROUND_COLORS } from "./stylemap";

const avDataKeys = [
  "paddingLeft",
  "paddingRight",
  "paddingTop",
  "paddingBottom",
  "firstLineIndent",
  "lineHeight",
];

export default class ParagraphDialog extends React.Component {
  constructor(props) {
    super(props);
    let data = {};
    const inputData =
      props.block && props.selectedBlocks.length === 1 ? props.block.data : {};

    avDataKeys.forEach((key) => {
      data[key] = inputData[key];
    });

    this.state = {
      data,
    };
  }

  onHide = () => {
    this.props.onHide();
  };

  onChange = (e) => {
    const { id, value } = e.target;
    this.setState((state) => {
      let data = state.data;
      data[id] = value;
      return { data };
    });
  };

  onSave = () => {
    this.props.onSave(this.state.data);
  };

  paddingClearAll = () => {
    this.setState((state) => {
      let data = state.data;
      data.paddingLeft = "";
      data.paddingRight = "";
      data.paddingTop = "";
      data.paddingBottom = "";
      data.firstLineIndent = "";
      return { data };
    });
  };

  render() {
    const lineHeights = [1, 2, 3, 4, 5, 6, 7, 8];
    return (
      <>
        <Modal show onHide={this.onHide}>
          <Modal.Header closeButton closeLabel="Закрыть">
            <Modal.Title>Абзац</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="form-group">
              <div className="d-flex justify-content-between mb-3">
                <label>Отступ (пт):</label>
                <div>
                  <button
                    title="Сбросить все отступы"
                    className="btn btn-light"
                    onClick={this.paddingClearAll}
                  >
                    Убрать все
                  </button>
                </div>
              </div>
              <div className="row">
                <div className="col-3">
                  <div className="form-group">
                    <label>Слева:</label>
                    <input
                      type="number"
                      id="paddingLeft"
                      className="form-control"
                      value={this.state.data.paddingLeft || ""}
                      onChange={this.onChange}
                      onKeyPress={(e) => {
                        if (e.key === "Enter") this.onSave();
                      }}
                    />
                  </div>
                </div>
                <div className="col-3">
                  <div className="form-group">
                    <label>Первая строка:</label>
                    <input
                      type="number"
                      id="firstLineIndent"
                      className="form-control"
                      value={this.state.data.firstLineIndent || ""}
                      onChange={this.onChange}
                      onKeyPress={(e) => {
                        if (e.key === "Enter") this.onSave();
                      }}
                    />
                  </div>
                </div>
                <div className="col-3">
                  <div className="form-group">
                    <label>Справа:</label>
                    <input
                      type="number"
                      id="paddingRight"
                      className="form-control"
                      value={this.state.data.paddingRight || ""}
                      onChange={this.onChange}
                      onKeyPress={(e) => {
                        if (e.key === "Enter") this.onSave();
                      }}
                    />
                  </div>
                </div>
                <div className="col-3">
                  <div className="form-group">
                    <label>Сверху:</label>
                    <input
                      type="number"
                      id="paddingTop"
                      className="form-control"
                      value={this.state.data.paddingTop || ""}
                      onChange={this.onChange}
                      onKeyPress={(e) => {
                        if (e.key === "Enter") this.onSave();
                      }}
                    />
                  </div>
                </div>
                <div className="col-3">
                  <div className="form-group">
                    <label>Снизу:</label>
                    <input
                      type="number"
                      id="paddingBottom"
                      className="form-control"
                      value={this.state.data.paddingBottom || ""}
                      onChange={this.onChange}
                      onKeyPress={(e) => {
                        if (e.key === "Enter") this.onSave();
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="form-group">
              <label>Межстрочный интервал:</label>
              <select
                id="lineHeight"
                value={this.state.data.lineHeight || ""}
                onChange={this.onChange}
                className="form-control"
              >
                <option value={""}>По умолчанию</option>
                {lineHeights.map((lh) => (
                  <option key={lh} value={lh}>
                    {parseInt(lh) * 0.5} пт.
                  </option>
                ))}
              </select>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <button title="Сохранить параметры абзаца" onClick={this.onSave} className="btn btn-primary">
              Сохранить
            </button>
            <button title="Закрыть без сохранения" onClick={this.onHide} className="btn btn-light">
              Отмена
            </button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}
